export const AGREEMENT_STATUS = {
    Pending: 0,
    Approved: 1,
    Rejected: 2,
}
export enum COUNTRY_DROPDOWN {
  Canada = 'Canada',
  USA = 'USA',
}

export enum ONBOARDING_STATUS {
  MasterAccountCreated = 1,
  OrderCreated = 2,
  TTAccountCreated = 3,
  PracticeActive = 4,
  AgreementAccepted = 7,
  ConfiguredPMS = 8,
  ProcessorSetupCompleted = 9,
}

export enum INACTIVE_ONBOARDING_STATUS_NAMES {
  OrderCreated = "Create Order",
  TTAccountCreated = "Create TT Account",
  AgreementAccepted = "Accept Agreement",
  ConfiguredPMS = "Configure PMS Details",
  ProcessorSetupCompleted = "Set Up Processor"
}


export enum MASTER_ACCOUNT_STATUS_TYPE {
  None =  0,
  SuperAdmin = 1,
  Practice = 2,
  Both = 3
}

export enum ACCOUNTSTATUS{
    MasterAccountCreated = 1,
    OrderCreated = 2,
    TTAccountCreated = 3,
    PracticeActive = 4,
    PracticeSuspended = 5,
    AccountClosed = 6
}
